import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'kn',
    fullName: 'Kannada',
    nativeName: 'ಕನ್ನಡ',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "ಸಮ್ಥಿಂಗ್ ಅಮೇಜಿಂಗ್ ಈಸ್ ಕಮಿಂಗ್",
    landing_subtitle: "ArgVoid ಒಂದು ಅಪ್ಲಿಕೇಶನ್ ಮತ್ತು ಆಟದ ಅಭಿವೃದ್ಧಿ ಸ್ಟುಡಿಯೋ ಆಗಿದೆ. ಟ್ಯೂನ್ ಆಗಿರಿ, ಹೊಸ ವಿಷಯಗಳು ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿವೆ!",
    select_language: "ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    search_placeholder: "ಭಾಷೆಗಳನ್ನು ಹುಡುಕಿ...",
    terms_title: "ಸೇವಾ ನಿಯಮಗಳು",
    policy_title: "ಗೌಪ್ಯತೆ ನೀತಿ",
    cookies_title: "ಕುಕಿ ನೀತಿ",
    terms_content: `
        <strong>1. ನಿಯಮಗಳ ಅಂಗೀಕಾರ</strong><br>
        ArgVoid ಅನ್ನು ಪ್ರವೇಶಿಸುವ ಮೂಲಕ, ಈ ಸೇವಾ ನಿಯಮಗಳನ್ನು ಒಪ್ಪಿಕೊಳ್ಳಲಾಗುತ್ತದೆ. ಈ ನಿಯಮಗಳನ್ನು ಒಪ್ಪದಿದ್ದರೆ, ಸೇವೆಯನ್ನು ಬಳಸಬಾರದು.<br><br>

        <strong>2. ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಬಳಕೆ</strong><br>
        ArgVoid ಮತ್ತು ಅದರ ಅಪ್ಲಿಕೇಶನ್‌ಗಳನ್ನು ಮಾಹಿತಿ ಮತ್ತು ಸೃಜನಾತ್ಮಕ ಉದ್ದೇಶಗಳಿಗಾಗಿ "ಇರುವಂತೆ" ಒದಗಿಸಲಾಗಿದೆ. ಸೇವೆಯನ್ನು ಕಾನೂನುಬದ್ಧ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಮಾತ್ರ ಬಳಸಬೇಕು.<br><br>

        <strong>3. ನಿಷೇಧಿತ ನಡವಳಿಕೆ</strong><br>
        ಸೈಟ್ ದುರ್ಬಲತೆಗಳನ್ನು ಬಳಸಿಕೊಳ್ಳುವುದು, ಸ್ಪ್ಯಾಮಿಂಗ್ ಅಥವಾ ಮೂಲಸೌಕರ್ಯಕ್ಕೆ ಅನಧಿಕೃತ ಪ್ರವೇಶವನ್ನು ಪ್ರಯತ್ನಿಸುವುದನ್ನು ಕಟ್ಟುನಿಟ್ಟಾಗಿ ನಿಷೇಧಿಸಲಾಗಿದೆ.<br><br>

        <strong>4. ಹಕ್ಕು ನಿರಾಕರಣೆ</strong><br>
        ಯಾವುದೇ ಸೂಚನೆ ಇಲ್ಲದೆ ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ವೇದಿಕೆ ಮತ್ತು ಸೇವೆಗಳನ್ನು ಮಾರ್ಪಡಿಸಬಹುದು. ಸೇವೆಯ ಸಮಯ ಅಥವಾ ಲಭ್ಯತೆಯ ಬಗ್ಗೆ ಯಾವುದೇ ಖಾತರಿಯನ್ನು ಒದಗಿಸಲಾಗಿಲ್ಲ.
    `,
    policy_content: `
        <strong>1. ಮಾಹಿತಿ ಸಂಗ್ರಹ</strong><br>
        ಈ ಸಮಯದಲ್ಲಿ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ಗೆ ಬಳಕೆದಾರರ ದೃಢೀಕರಣ ಅಥವಾ ಖಾತೆ ರಚನೆಯ ಅಗತ್ಯವಿರುವುದಿಲ್ಲ. ಸಂದರ್ಶಕರಿಂದ ಯಾವುದೇ ವೈಯಕ್ತಿಕ ಗುರುತಿಸುವ ಮಾಹಿತಿಯನ್ನು (ಹೆಸರುಗಳು ಅಥವಾ ಇಮೇಲ್ ವಿಳಾಸಗಳು) ಸಕ್ರಿಯವಾಗಿ ಸಂಗ್ರಹಿಸಲಾಗುವುದಿಲ್ಲ.<br><br>

        <strong>2. ಬಳಕೆಯ ಡೇಟಾ</strong><br>
        ಸೈಟ್ ಟ್ರಾಫಿಕ್ ಅನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಲು ಮತ್ತು ಅಪ್ಲಿಕೇಶನ್‌ಗಳನ್ನು ಸುಧಾರಿಸಲು ಮೂಲ, ಅನಾಮಧೇಯ ವಿಶ್ಲೇಷಣೆಗಳನ್ನು ಸಂಗ್ರಹಿಸಬಹುದು. ಈ ಡೇಟಾವನ್ನು ವೈಯಕ್ತಿಕ ಬಳಕೆದಾರ ಗುರುತುಗಳಿಗೆ ಲಿಂಕ್ ಮಾಡಲಾಗಿಲ್ಲ.<br><br>

        <strong>3. ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಸೇವೆಗಳು</strong><br>
        ಹೋಸ್ಟಿಂಗ್ ಮತ್ತು ಅನಾಲಿಟಿಕ್ಸ್ ಸೇವೆಗಳಿಗೆ ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಪೂರೈಕೆದಾರರನ್ನು ಬಳಸಿಕೊಳ್ಳಬಹುದು. ಈ ಸಂಬಂಧಿತ ಪೂರೈಕೆದಾರರ ಗೌಪ್ಯತೆ ಅಭ್ಯಾಸಗಳು ಅವರ ಮೂಲಸೌಕರ್ಯದಲ್ಲಿ ಸಂಸ್ಕರಿಸಿದ ಅನಾಮಧೇಯ ಡೇಟಾವನ್ನು ನಿಯಂತ್ರಿಸುತ್ತವೆ.<br><br>

        <strong>4. ಡೇಟಾ ಭದ್ರತೆ</strong><br>
        ವೇದಿಕೆಯನ್ನು ರಕ್ಷಿಸಲು ಸಮಂಜಸವಾದ ಭದ್ರತಾ ಕ್ರಮಗಳನ್ನು ಅಳವಡಿಸಲಾಗಿದೆ. ಆದಾಗ್ಯೂ, ಇಂಟರ್ನೆಟ್ ಮೂಲಕ ಯಾವುದೇ ಸಂವಹನ ವಿಧಾನವು ಸಂಪೂರ್ಣವಾಗಿ ಸುರಕ್ಷಿತವಲ್ಲ.<br><br>
    `,
    cookies_content: `
        <strong>1. ಕುಕೀಸ್ ಮತ್ತು ಸ್ಥಳೀಯ ಸಂಗ್ರಹಣೆ ಎಂದರೇನು?</strong><br>
        ಕುಕೀಗಳು ಮತ್ತು ಬ್ರೌಸರ್ ಸ್ಥಳೀಯ ಸಂಗ್ರಹಣೆಯು ಭೇಟಿಗಳಾದ್ಯಂತ ಕಾನ್ಫಿಗರೇಶನ್ ಆದ್ಯತೆಗಳನ್ನು ನೆನಪಿಟ್ಟುಕೊಳ್ಳಲು ಸಾಧನದಲ್ಲಿ ಸಂಗ್ರಹಿಸಲಾದ ಸಣ್ಣ ಡೇಟಾ ಫೈಲ್‌ಗಳಾಗಿವೆ.<br><br>

        <strong>2. ಬಳಕೆಯ ಉದ್ದೇಶ</strong><br>
        ಬ್ರೌಸರ್ ಲೋಕಲ್ ಸ್ಟೋರೇಜ್ ಅನ್ನು ಕಾನ್ಫಿಗರೇಶನ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಉಳಿಸಲು ಕಟ್ಟುನಿಟ್ಟಾಗಿ ಬಳಸಲಾಗುತ್ತದೆ, ಉದಾಹರಣೆಗೆ:<br>
        - ಭಾಷಾ ಪ್ರಾಶಸ್ತ್ಯಗಳು<br>
        - ಬಳಕೆದಾರ ಇಂಟರ್ಫೇಸ್ ಕಾನ್ಫಿಗರೇಶನ್ (ಉದಾ., ಲೇಔಟ್ ಅಥವಾ ಥೀಮ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳು)<br>
        - ತಾತ್ಕಾಲಿಕ ಅಪ್ಲಿಕೇಶನ್ ಸಂಗ್ರಹ<br><br>

        <strong>3. ಟ್ರ್ಯಾಕಿಂಗ್ </strong><br> ಇಲ್ಲ
        ಕುಕೀಸ್ ಮತ್ತು ಸ್ಥಳೀಯ ಸಂಗ್ರಹಣೆಯನ್ನು ಜಾಹೀರಾತು ಅಥವಾ ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಟ್ರ್ಯಾಕಿಂಗ್ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಬಳಸಲಾಗುವುದಿಲ್ಲ. ಎಲ್ಲಾ ಸಂಗ್ರಹಿಸಲಾದ ಡೇಟಾವು ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ನ ಪ್ರಮುಖ ಕಾರ್ಯಕ್ಕಾಗಿ ಕಟ್ಟುನಿಟ್ಟಾಗಿ.<br><br>

        <strong>4. ಕಂಟ್ರೋಲ್</strong><br>
        ಬ್ರೌಸರ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳ ಮೂಲಕ ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ಬ್ರೌಸರ್ ಡೇಟಾವನ್ನು ತೆರವುಗೊಳಿಸಬಹುದು, ಅದು ಯಾವುದೇ ಸ್ಥಳೀಯ ಕಾನ್ಫಿಗರೇಶನ್‌ಗಳನ್ನು ಮರುಹೊಂದಿಸುತ್ತದೆ.
    `,
    cookie_consent_text: "ನಿಮ್ಮ ಅಧಿವೇಶನವನ್ನು ಸಕ್ರಿಯವಾಗಿರಿಸುವುದು, ನಿಮ್ಮ ಭಾಷೆಯ ಆದ್ಯತೆಯನ್ನು ಉಳಿಸುವುದು ಮತ್ತು ಇತರ ಕಸ್ಟಮ್ ಕಾನ್ಫಿಗರೇಶನ್‌ಗಳಂತಹ ವೆಬ್‌ಸೈಟ್ ಕಾರ್ಯಗಳನ್ನು ಸರಿಯಾಗಿ ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು ನಾವು ಮೂಲ ಕುಕೀಗಳನ್ನು ಬಳಸುತ್ತೇವೆ.",
    read_policy: "ಕುಕಿ ನೀತಿಯನ್ನು ಓದಿ",
    support_title: "ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    support_subject_label: "ವಿಷಯ",
    support_message_label: "ಸಂದೇಶ",
    support_submit_button: "ಸಂದೇಶ ಕಳುಹಿಸಿ",
    support_hint: "ಗಮನಿಸಿ: ಸಂದೇಶವನ್ನು ಕಳುಹಿಸಲು ಇದು ನಿಮ್ಮ ಡೀಫಾಲ್ಟ್ ಇಮೇಲ್ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ತೆರೆಯುತ್ತದೆ.",
    support_success_msg: "ನಿಮ್ಮ ಇಮೇಲ್ ಅಪ್ಲಿಕೇಶನ್ ತೆರೆಯಲಾಗುತ್ತಿದೆ...",
    support_error_msg: "ಸಂದೇಶ ಕಳುಹಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    explorer_title: "ಅನ್ವೇಷಕ",
    history_title: "ಇತಿಹಾಸ",
    animation_title: "ಅನಿಮೇಷನ್",
    config_title: "ಸಂರಚನೆ",
    tool_mouse: "ಆಯ್ಕೆಮಾಡಿ (Ctrl+M)",
    tool_brush: "ಬ್ರಷ್ (Ctrl+B)",
    tool_brush_mode: "ಟಾಗಲ್ ಮೋಡ್ (ಘನ/ತೆರವು)",
    tool_eraser: "ಎರೇಸರ್ (Ctrl+E)",
    tool_brush_size: "ಬ್ರಷ್ ಗಾತ್ರವನ್ನು ಹೊಂದಿಸಿ",
    tool_bucket: "ಭರ್ತಿ ಮಾಡಿ (Ctrl+F)",
    tool_eyedropper: "ಐಡ್ರಾಪರ್",
    tool_grid: "ಗ್ರಿಡ್ (Ctrl+Shift+B)",
    tool_rotate: "ತಿರುಗಿಸಿ (Ctrl+Shift+R)",
    tool_flip_h: "ಫ್ಲಿಪ್ ಎಚ್ (Ctrl+Shift+H)",
    tool_flip_v: "ಫ್ಲಿಪ್ ವಿ (Ctrl+Shift+V)",
    tool_transpose: "ವರ್ಗಾಯಿಸು (Ctrl+Shift+T)",
    label_width: "ಅಗಲ",
    label_height: "ಎತ್ತರ",
    label_frames: "ಚೌಕಟ್ಟುಗಳ ಸಂಖ್ಯೆ",
    label_animation: "ಅನಿಮೇಷನ್ ಶೈಲಿ",
    label_background_color: "ಹಿನ್ನೆಲೆ ಬಣ್ಣ",
    label_interval: "ಮಧ್ಯಂತರ",
    tool_anim_config: "ಅನಿಮೇಷನ್ ಕಾನ್ಫಿಗರೇಶನ್",
    label_new_width: "ಹೊಸ ಅಗಲ",
    label_new_height: "ಹೊಸ ಎತ್ತರ",
    label_apply: "ಅನ್ವಯಿಸು",
    label_colors: "ಬಣ್ಣಗಳು",
    label_size: "ಗಾತ್ರ",
    label_tolerance: "ಸಹಿಷ್ಣುತೆ",
    val_horizontal: "ಸಮತಲ",
    val_vertical: "ಲಂಬವಾದ",
    val_sequence: "ಅನುಕ್ರಮ",
    val_bounce: "ಬೌನ್ಸ್",
    val_random: "ಯಾದೃಚ್ಛಿಕ",
    val_solid: "ಘನ",
    val_clear: "ತೆರವುಗೊಳಿಸಿ",
    action_add_sheet: "ಹೊಸ ಹಾಳೆ",
    action_import: "ಆಮದು ಮಾಡಿಕೊಳ್ಳಿ",
    action_export: "ರಫ್ತು ಮಾಡಿ",
    action_sort_projects: "ವಿಂಗಡಿಸು",
    sort_date_old: "ಅತ್ಯಂತ ಹಳೆಯ ಮೊದಲ",
    sort_date_new: "ಹೊಸದು ಮೊದಲನೆಯದು",
    sort_name_az: "ಹೆಸರು (A-Z)",
    sort_name_za: "ಹೆಸರು (Z-A)",
    action_new_sprite: "ಹೊಸ ಸ್ಪ್ರೈಟ್",
    action_new_project: "ಹೊಸ ಯೋಜನೆ",
    modal_save_all_title: "ಎಲ್ಲಾ ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ",
    modal_save_all_desc: "ಉಳಿಸಲು ಸ್ವತ್ತುಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ:",
    modal_save_selected: "ಆಯ್ಕೆಮಾಡಿದ ಉಳಿಸಿ",
    action_saved: "ಉಳಿಸಲಾಗಿದೆ",
    modal_create_sprite_title: "ಹೊಸ ಸ್ಪ್ರೈಟ್ ರಚಿಸಿ",
    modal_create_project_title: "ಹೊಸ ಯೋಜನೆಯನ್ನು ರಚಿಸಿ",
    modal_add_sheet_title: "ಹೊಸ ಶೀಟ್ ಸೇರಿಸಿ",
    modal_rename_sheet_title: "ಶೀಟ್ ಅನ್ನು ಮರುಹೆಸರಿಸಿ",
    modal_rename_sprite_title: "ಸ್ಪ್ರೈಟ್ ಅನ್ನು ಮರುಹೆಸರಿಸಿ",
    modal_delete_sprite_title: "ಸ್ಪ್ರೈಟ್ ಅನ್ನು ಅಳಿಸಿ",
    modal_delete_project_title: "ಯೋಜನೆಯನ್ನು ಅಳಿಸಿ",
    modal_delete_sheet_title: "ಹಾಳೆಯನ್ನು ಅಳಿಸಿ",
    placeholder_sprite_name: "ಹೆಸರು",
    placeholder_project_name: "ಹೆಸರು",
    placeholder_sheet_name: "ಹೆಸರು",
    placeholder_new_name: "ಹೊಸ ಹೆಸರು",
    action_create: "ರಚಿಸಿ",
    action_add: "ಸೇರಿಸಿ",
    action_rename: "ಮರುಹೆಸರಿಸು",
    action_duplicate: "ನಕಲು",
    action_delete: "ಅಳಿಸಿ",
    action_cancel: "ರದ್ದುಮಾಡು",
    confirm_delete_sprite: "ಈ ಸ್ಪ್ರೈಟ್ ಅನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?",
    confirm_delete_project: "ಈ ಯೋಜನೆಯನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ? ಎಲ್ಲಾ ಸ್ಪ್ರಿಟ್‌ಗಳನ್ನು ತೆಗೆದುಹಾಕಲಾಗುತ್ತದೆ.",
    confirm_delete_sheet: "ಈ ಹಾಳೆಯನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?",
    err_select_sprite: "ದಯವಿಟ್ಟು ಮೊದಲು ಸ್ಪ್ರೈಟ್ ಅನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
    err_select_project: "ದಯವಿಟ್ಟು ಮೊದಲು ಯೋಜನೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
    err_name_empty: "ಹೆಸರು ಖಾಲಿ ಇರುವಂತಿಲ್ಲ.",
    err_sprite_exists: "ಆ ಹೆಸರಿನ ಸ್ಪ್ರೈಟ್ ಈಗಾಗಲೇ ಅಸ್ತಿತ್ವದಲ್ಲಿದೆ.",
    err_project_exists: "ಆ ಹೆಸರಿನ ಯೋಜನೆಯು ಈಗಾಗಲೇ ಅಸ್ತಿತ್ವದಲ್ಲಿದೆ.",
    err_no_content: "ಉಳಿಸಲು ಯಾವುದೇ ವಿಷಯವಿಲ್ಲ.",
    err_no_changes: "ಉಳಿಸಲು ಯಾವುದೇ ಬದಲಾವಣೆಗಳಿಲ್ಲ.",
    err_delete_last_sheet: "ಕೊನೆಯ ಹಾಳೆಯನ್ನು ಅಳಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ.",
    err_extract_frames: "ಯಾವುದೇ ಚೌಕಟ್ಟುಗಳನ್ನು ಹೊರತೆಗೆಯಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.",
    err_indexeddb: "ಸ್ಥಳೀಯವಾಗಿ ಉಳಿಸಲು ವಿಫಲವಾಗಿದೆ. ನಿಮ್ಮ ಬ್ರೌಸರ್ IndexedDB ಅನ್ನು ಬೆಂಬಲಿಸದೇ ಇರಬಹುದು.",
    msg_upload_success: "ಅಪ್‌ಲೋಡ್ ಯಶಸ್ವಿಯಾಗಿದೆ: {0}",
    msg_upload_failed: "ಅಪ್‌ಲೋಡ್ ವಿಫಲವಾಗಿದೆ: {0}",
    msg_save_success: "ಉಳಿಸಿ ಯಶಸ್ವಿಯಾಗಿದೆ.",
    msg_saving: "ಉಳಿಸಲಾಗುತ್ತಿದೆ...",
    msg_multi_save_result: "{0} ಸ್ವತ್ತುಗಳನ್ನು ಉಳಿಸಲಾಗಿದೆ. {1} ವೈಫಲ್ಯಗಳು.",
    menu_title: "ಮೆನು",
    menu_save: "ಉಳಿಸಿ",
    menu_save_all: "ಎಲ್ಲವನ್ನೂ ಉಳಿಸಿ",
    menu_support: "ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    label_local_storage: "ಸ್ಥಳೀಯ ಸಂಗ್ರಹಣೆ",
    label_sign_in: "ಸೈನ್ ಇನ್ ಮಾಡಿ",
    modal_export_title: "ಸ್ಪ್ರೈಟ್ ಅನ್ನು ರಫ್ತು ಮಾಡಿ",
    label_filename: "ಫೈಲ್ ಹೆಸರು",
    label_format: "ಫಾರ್ಮ್ಯಾಟ್",
    action_export_confirm: "ರಫ್ತು ಮಾಡಿ",
};

export default translations;
